import Button from "@/common/components/Button";
import ResumeItem from "@/common/components/ResumeItem";
import { Building2Icon, PlusIcon } from "lucide-react";
import { useEffect, useState } from "react";
import EquipmentRow from "./EquipmentRow";
import { ParsedBranchesEquipmentsConsumptionsTotalizerData } from "@/features/movementsTotalizer/types/branchesEquipmentsConsumptionsTotalizer.type";
import { branchesEquipmentsConsumptionsTotalizerColumns } from "@/features/movementsTotalizer/constants/branchesEquipmentsConsumptionsTotalizerColumns.constant";

interface BranchRowProps {
  branch: ParsedBranchesEquipmentsConsumptionsTotalizerData;
  fetchAllBranchEquipments?: (params: {
    clientBranchId: string;
    equipmentsCountLimit: number;
  }) => void;
  print?: boolean;
}

const BranchRow = ({
  branch,
  fetchAllBranchEquipments,
  print,
}: BranchRowProps) => {
  const [isFetchingAllBranchEquipments, setIsFetchingAllBranchEquipments] = useState(false);

  useEffect(() => {
    setIsFetchingAllBranchEquipments(false);
  }, [branch.equipments.length, branch.equipmentsCount]);

  return (
    <tbody key={branch.id} className="">
      <tr>
        <td colSpan={branchesEquipmentsConsumptionsTotalizerColumns.length} className="p-0 pt-3 print:pt-0 print:border-x print:border-neutral-300">
          <div
            className={`
              flex items-center justify-between gap-8 p-3 bg-white-200/20 rounded-t-lg
              print:rounded-t-none print:bg-neutral-300
            `}
          >
            <div className="flex items-center gap-3">
              <Building2Icon strokeWidth={1.5} size={22} className="text-warning print:text-black" />

              <ResumeItem
                label="Filial"
                value={branch.displayName}
                className="text-warning print:font-medium"
                labelClassName="text-xs print:text-black"
                valueClassName="text-sm print:text-black"
              />
            </div>
          </div>
        </td>
      </tr>

      {branch.equipments.map((equipment) => (
        <EquipmentRow
          key={equipment.identifier}
          equipment={equipment}
        />
      ))}

      {!print && fetchAllBranchEquipments && branch.equipments.length !== branch.equipmentsCount && (
        <tr>
          <td colSpan={branchesEquipmentsConsumptionsTotalizerColumns.length} className="p-0">
            <Button
              variant="neutral"
              className="w-full h-9 rounded-none text-blue-800 bg-white-100/15 hover:bg-white-100/25 disabled:bg-white-100/15 disabled:hover:bg-white-100/15 disabled:opacity-95 transition-colors"
              onClick={() => {
                setIsFetchingAllBranchEquipments(true);
                fetchAllBranchEquipments({
                  clientBranchId: branch.id,
                  equipmentsCountLimit: branch.equipmentsCount,
                });
              }}
              isLoading={isFetchingAllBranchEquipments}
              disabled={isFetchingAllBranchEquipments}
              hideContentOnLoading
            >
              <PlusIcon size={16} />

              Exibir mais equipamentos
            </Button>
          </td>
        </tr>
      )}

      <tr>
        <td colSpan={branchesEquipmentsConsumptionsTotalizerColumns.length} className="p-0 print:border-x print:border-neutral-200">
          <div className="flex items-center justify-between gap-8 p-3 bg-white-200/20 rounded-b-lg print:rounded-b-none print:bg-neutral-300/50 print:font-semibold">
            <p className="">
              Valor total da filial
            </p>

            <p>
              {branch.totalAmount}
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  );
}

export default BranchRow;
